


















import { Component, Vue } from 'vue-property-decorator';
import { isiOS } from '@/utils/common';

@Component({
  name: 'LandingPage'
})

export default class LandingPage extends Vue {
  downloadAppUrl = '';

  created() {
    document.title = '俏租机';

    if (isiOS()) {
      this.downloadAppUrl = 'https://itunes.apple.com/cn/app/id1543645253';
    } else {
      this.downloadAppUrl = 'https://qiaozuji-flms-public.oss-cn-shenzhen.aliyuncs.com/app/android/apk/dingdong/com.qiaozuji.android.apk';
    }
  }
}
